import React from 'react';

const OrderConsumableIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25281 3.46803C6.81726 -0.355162 11.5959 -1.12882 14.649 1.70504C17.702 4.5389 17.8643 12.3602 14.649 15.8089C11.4337 19.2576 4.023 18.1512 1.49955 15.8089C-1.0239 13.4667 -0.311651 7.29121 3.25281 3.46803Z"
      fill="#FB9318"
      {...props}
    />
    <path
      d="M13.2856 7.82353H12.4945V6.53188C12.4945 6.14618 12.1807 5.83237 11.795 5.83237H11.0084C10.9089 5.59932 10.6775 5.43555 10.4086 5.43555H8.59142C8.32248 5.43555 8.09104 5.59932 7.99164 5.83237H7.20496C6.81925 5.83237 6.50546 6.14618 6.50546 6.53188V7.82353H5.71436C5.31983 7.82353 5 8.14337 5 8.53791C5 8.93245 5.31983 9.25227 5.71436 9.25227H13.2856C13.6801 9.25227 14 8.93243 14 8.53791C14 8.14337 13.6802 7.82353 13.2856 7.82353ZM7.0328 6.53188C7.0328 6.43696 7.11004 6.35972 7.20496 6.35972H7.99944C8.1028 6.58338 8.32928 6.73895 8.5914 6.73895H10.4086C10.6707 6.73895 10.8972 6.58336 11.0005 6.35972H11.795C11.8899 6.35972 11.9672 6.43696 11.9672 6.53188V7.82353H7.0328V6.53188Z"
      fill="white"
    />
    <path
      d="M5.52734 12.8663C5.52734 13.251 5.84034 13.564 6.22505 13.564H12.7749C13.1596 13.564 13.4726 13.251 13.4726 12.8663V9.77979H5.52734V12.8663ZM8.72526 11.4082H9.23633V10.8971C9.23633 10.7515 9.35438 10.6335 9.5 10.6335C9.64562 10.6335 9.76367 10.7515 9.76367 10.8971V11.4082H10.2747C10.4204 11.4082 10.5384 11.5263 10.5384 11.6719C10.5384 11.8175 10.4204 11.9355 10.2747 11.9355H9.76367V12.4466C9.76367 12.5922 9.64562 12.7103 9.5 12.7103C9.35438 12.7103 9.23633 12.5922 9.23633 12.4466V11.9355H8.72526C8.57964 11.9355 8.46159 11.8175 8.46159 11.6719C8.46159 11.5263 8.57964 11.4082 8.72526 11.4082Z"
      fill="white"
    />
  </svg>
);

export default OrderConsumableIcon;
